<script>
	const _ = require('underscore');
	const routeContext = require('core/routeContext');
	const { onWeeblyLinkClick } = require('utilities/weeblyUtilities');
	const menuKey = 'Teacher Guide';

	module.exports = {
		components: {
			'weebly-iframe': require('components/weebly-iframe.vue').default,
			'teacher-guide-table-of-contents': require('components/teacher-guide-table-of-contents.vue').default,
			'teacher-guide-modal': require('components/teacher-guide-modal.vue').default
		},
		props: {
			routeContext: {
				default: {}
			}
		},
		data() {
			let rootPath = '/teacher-guide';
			let path = (routeContext && routeContext.getParam('path')) || '';
			return {
				path,
				rootPath
			};
		},
		modelData: ['userContext', 'weeblyMenus'],
		computed: {
			eventData() {
				let path = this.path;
				let rootPath = this.rootPath;
				return { path: rootPath + path };
			},
			tableOfContents() {
				let weeblyMenus = this.weeblyMenus;
				let table = (weeblyMenus && weeblyMenus[menuKey]) || [];

				return table;
			},
			isRoot() {
				const path = (this.path || '').replace('.html', '');
				return path === '' || path === '/';
			},
			crumbMap() {
				let map = {};
				let tableOfContents = this.tableOfContents;

				if (tableOfContents.length) {
					map = this.createBreadCrumbMap([...tableOfContents]);
				}
				return map;
			},
			breadcrumbs() {
				let isRoot = this.isRoot;
				let rootPath = this.rootPath;
				let path = this.path;
				let key = rootPath + path;
				let crumbMap = this.crumbMap || {};
				let rootNode = {
					label: menuKey,
					href: rootPath
				};
				let crumbs = crumbMap[key] || [];

				return isRoot ? [] : [rootNode].concat(crumbs);
			}
		},
		methods: {
			createBreadCrumbMap(nodes, ...parents) {
				let map = {};
				let rootPath = this.rootPath;
				parents = parents || [];

				nodes.forEach(node => {
					let key = rootPath + node.href;
					let label = node.label;
					let href = node.href;
					let mapNode = { label, href };
					let nodesSoFar = parents.concat([mapNode]);
					map[key] = nodesSoFar;
					if (node.navItems && node.navItems.length) {
						_.assign(map, this.createBreadCrumbMap(node.navItems, ...nodesSoFar));
					}
				});
				return map;
			},
			onTOCLinkClick(anchor) {
				onWeeblyLinkClick(anchor, this.rootPath);
			}
		},
		watch: {
			'routeContext.path'() {
				this.path = routeContext.getParam('path');
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';

	.teacher-guide {
		position: relative;

		&.root {
			display: flex;
			align-items: flex-start;
		}

		.teacher-guide-table-of-contents {
			display: none;
			flex: 1;
			margin-top: 0.5rem;
		}

		.weebly-iframe {
			flex: 3;
		}

		.breadcrumbs {
			display: none;
			position: relative;
			z-index: 5;
			height: 2rem;
			margin-top: 0.5rem;
			margin-bottom: -2.5rem;

			&.mobile {
				display: block;
			}

			.crumb {
				color: white;
				margin-right: 0.25rem;

				&.crumb-link:hover {
					text-decoration: underline;
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.teacher-guide {
			.breadcrumbs {
				display: block;

				&.mobile {
					display: none;
				}
			}

			.teacher-guide-table-of-contents {
				display: flex;
			}
		}
	}
</style>
<template>
	<main
		class="teacher-guide"
		:class="{
			wrapper: isRoot,
			root: isRoot
		}">
		<teacher-guide-table-of-contents
			v-if="isRoot && tableOfContents && tableOfContents.length"
			:contents="tableOfContents"
			:on-link-click="onTOCLinkClick">
		</teacher-guide-table-of-contents>
		<div
			class="breadcrumbs wrapper"
			v-if="!isRoot && breadcrumbs">
			<template v-for="(crumb, idx) in breadcrumbs">
				<a
					:href="crumb.href"
					@click.stop.prevent="onTOCLinkClick($event.currentTarget)"
					class="crumb crumb-link"
					:class="{
						'text-bold': idx === breadcrumbs.length - 1
					}"
					>{{ crumb.label }}</a
				>
				<span
					v-if="idx < breadcrumbs.length - 1"
					class="crumb crumb-arrow fa"
					>></span
				>
			</template>
		</div>
		<div
			class="breadcrumbs wrapper mobile"
			v-if="!isRoot && breadcrumbs && breadcrumbs.length > 1">
			<a
				:href="breadcrumbs[breadcrumbs.length - 2].href"
				@click.stop.prevent="onTOCLinkClick($event.currentTarget)"
				class="crumb crumb-link"
				>&lt; {{ breadcrumbs[breadcrumbs.length - 2].label }}</a
			>
		</div>
		<weebly-iframe
			:path="path"
			:root-path="rootPath"
			:weebly-root-path="'/teacher-guide.html'"
			:event-data="eventData"></weebly-iframe>
		<teacher-guide-modal></teacher-guide-modal>
	</main>
</template>
